<template>
  <div>
    <v-card class="mx-auto" width="50%">
      <v-card-title>
        <v-toolbar-title>Enviar Notificação</v-toolbar-title>
      </v-card-title>
      <v-card-text>
        <v-text-field
          ref="title"
          v-model="title"
          color="black"
          auto-grow="true"
          clearable="true"
          row-height="24"
          label="Titulo"
          :rules="[
              () => !!title || 'Esse campo é obrigatório',
            ]"
        ></v-text-field>
        <v-textarea
          ref="body"
          v-model="body"
          color="black"
          auto-grow="true"
          clearable="true"
          row-height="24"
          label="Mensagem"
          counter="140"
          :rules="[
              () => !!body || 'Esse campo é obrigatório',
              () => !!body && body.length <= 140 || 'A mensagem deve ter menos de 140 caracteres',
            ]"
        ></v-textarea>
      </v-card-text>
      <v-card-actions>
        <v-btn dark rounded color="darken-2" class="text-transform-none" @click="enviar()">
          <v-icon style="margin-right: 6px">chat_bubble_outline</v-icon>Enviar
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import PushService from "@/services/pushService.js";
export default {
  data: () => ({
    title: null,
    body: null,
  }),
  methods: {
    async enviar() {
      await PushService.enviar({ title: this.title, body: this.body });
      this.$toast.info("Push solicitado com sucesso.");
    },
  },
};
</script>

<style>
</style>
